module.exports = __webpack_public_path__ + "static/img/Ethan-Ferguson.7ad3fff.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Ethan-Ferguson.jpg
// module id = 7A0T
// module chunks = 0